import React from 'react';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedItems from './components/FeaturedItems';
import MenuSection from './components/MenuSection';
import ContactSection from './components/ContactSection';
import LocationSection from './components/LocationSection';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-[#0a1929]">
        <Header />
        <main>
          <Hero />
          <FeaturedItems />
          <MenuSection />
          <ContactSection />
          <LocationSection />
        </main>
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;